import { Alert } from '@ksyos/design-system';
import { useParams } from '@ksyos/router';
import type { OrderSuppliesRouteParams } from '../../types/orderSuppliesRouteParams';

export function OrderSuppliesOrderAlert() {
    const { supplyCategory } = useParams() as OrderSuppliesRouteParams;

    if (supplyCategory === 'ecgElectrodes') {
        return (
            <Alert appearance="info">
                <Alert.Text fontWeight="bold">
                    De aansluiting van de plakkers die achter de merknaam staat genoemd verwijst naar de elektrodekabel
                    die je gebruikt. De korting is al verrekend in de prijs.
                    <br />
                    <br />
                    Wil je een ander type plakker of heb je hulp nodig bij het uitzoeken welke plakker je nodig hebt?
                    Mail dan naar{' '}
                    <Alert.Link
                        href="mailto:cardiologie@ksyos.nl"
                        variant="externalLink"
                    >
                        cardiologie@ksyos.nl
                    </Alert.Link>{' '}
                    of bel naar{' '}
                    <Alert.Link
                        href="tel:+31206000060"
                        variant="externalLink"
                    >
                        020 600 00 60
                    </Alert.Link>
                    .
                </Alert.Text>
            </Alert>
        );
    }

    return null;
}
